import { render, staticRenderFns } from "./BtnInserirPrestacaoContasMensal.vue?vue&type=template&id=a32b40e8"
import script from "./BtnInserirPrestacaoContasMensal.vue?vue&type=script&lang=js"
export * from "./BtnInserirPrestacaoContasMensal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports